import { render } from "./TopAttributesTable.vue?vue&type=template&id=200960fe&scoped=true"
import script from "./TopAttributesTable.vue?vue&type=script&lang=js"
export * from "./TopAttributesTable.vue?vue&type=script&lang=js"

import "./TopAttributesTable.vue?vue&type=style&index=0&id=200960fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200960fe"]])

export default __exports__